// The upload-kind vocabulary on the FE: the create-time default and the label a
// file row shows for its kind.

// The kind a freshly-picked file is created with. Extraction replaces it with the
// kind classified from the content. Mirrors DEFAULT_UPLOAD_KIND in
// db/models/upload.py (tests/unit/test_upload_kinds_web_mirror.py).
export const DEFAULT_UPLOAD_KIND = "other";

// Tokens that render uppercase rather than sentence-cased ("EPC cost").
const KIND_ACRONYMS: ReadonlySet<string> = new Set(["epc"]);

const formatKind = (kind: string): string => {
  const parts = kind.split("_").map((p) =>
    KIND_ACRONYMS.has(p) ? p.toUpperCase() : p,
  );
  const joined = parts.join(" ");
  return joined.charAt(0).toUpperCase() + joined.slice(1);
};

// The label a file row shows for its kind, or null when the kind says nothing
// (missing, or the catch-all).
export const kindLabel = (kind: string | null | undefined): string | null =>
  kind && kind !== DEFAULT_UPLOAD_KIND ? formatKind(kind) : null;
